import { useState } from 'react';
import { ON_SERVER } from 'helpers';
import { useUser } from 'contexts/user-context';
import { useAnalytics } from 'contexts/analytic-context';

const Segment: React.FC = () => {
  const { user } = useUser();
  const [userId, setUserId] = useState('');
  const { identifyUser } = useAnalytics();

  if (ON_SERVER) return null;

  if (user?.id && userId !== user?.id) {
    // @ts-ignore
    identifyUser({
      id: user?.id,
      source: 'root_segment_component',
      data: {
        phone: user?.phone,
        email: user?.email,
        ageVerified: user?.idVerificationStatus !== 'APPROVED',
      },
    });

    setUserId(user?.id);
  }

  return null;
};

export default Segment;
